import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { BrowserLifecycleService } from './vscode/src/vs/workbench/services/lifecycle/browser/lifecycleService.js';
import { ILifecycleService } from 'vscode/vscode/vs/workbench/services/lifecycle/common/lifecycle.service';
import { TimerService } from './vscode/src/vs/workbench/services/timer/browser/timerService.js';
import { ITimerService } from 'vscode/vscode/vs/workbench/services/timer/browser/timerService.service';

function getServiceOverride() {
    return {
        [( ILifecycleService.toString())]: new SyncDescriptor(BrowserLifecycleService),
        [( ITimerService.toString())]: new SyncDescriptor(TimerService)
    };
}

export { getServiceOverride as default };
